// extracted by mini-css-extract-plugin
export var attachmentContainer = "_j6-0";
export var fileList = "_j6-2";
export var removeFileButton = "_j6-1";